import { twMerge } from 'tailwind-merge';

import './DropdownDivider.css';

export const DropdownDivider = ({ className }: { className?: string }) => {
  return <div className={twMerge('h-px bg-v2blueGray-200 w-full dropdown-divider', className)} />;
};
